export const EPageSlug = {
  ID_SEARCH_OPTIONAL: ':search_id?',

  ID_WORKSPACE_OPTIONAL: ':workspace_id?',

  ID_GENERATION: ':generation_id',
  ID_GENERATION_OPTIONAL: ':generation_id?',

  ID_USER_TASK: ':user_task_id',
  ID_USER_TASK_OPTIONAL: ':user_task_id?',

  ID_COLLECTION_OPTIONAL: ':collection_id?',
  ID_COLLECTION: ':collection_id',

  PAYMENT_STATUS: ':payment_status',

  TOKEN_MAGIC_LINK: ':token_magic_link',
  TOKEN_EMAIL_VERIFICATION: ':token_email_verification',
  TOKEN_USER_WORKSPACE_INVITATION: ':token_user_workspace_invitation',
};
